import { Router } from "@frui.ts/screens";
import { attachAutomaticValidator } from "@frui.ts/validation";
import { Modules } from "config";
import type { interfaces } from "inversify";
import EventBus from "services/eventBus";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import SecurityService from "services/securityService";
import UpdateCountryRequest, { CountryValidationRules } from "entities/updateCountryRequest";
import EditableDetailViewModel from "viewModels/editableDetailViewModel";
import EnumRepository from "repositories/enumRepository";

@Router.registerRoute({ name: Router.Self, route: ":countryId" })
export default class CountryDetailViewModel extends EditableDetailViewModel<UpdateCountryRequest> {
  readonly modelName = "country";

  constructor(
    protected itemId: string,
    protected repository: EnumRepository,
    protected localizationService: LocalizationService,
    protected eventBus: EventBus,
    protected notificationService: NotificationService,
    protected securityService: SecurityService
  ) {
    super(itemId);
  }

  protected async loadDetail() {
    const item = await this.repository.get<UpdateCountryRequest>(this.itemId, "countries", UpdateCountryRequest, "1.2");
    attachAutomaticValidator(item, CountryValidationRules);

    return item;
  }

  updateData() {
    return this.repository.update(this.item, "countries", UpdateCountryRequest, "1.2");
  }

  translate(code: string, size?: number): string {
    return this.localizationService.translateModule(Modules.timeCharges, `countries.${code}`, size);
  }

  static Factory({ container }: interfaces.Context) {
    return (itemId: string) =>
      new CountryDetailViewModel(
        itemId,
        container.get(EnumRepository),
        container.get(LocalizationService),
        container.get(EventBus),
        container.get(NotificationService),
        container.get(SecurityService)
      );
  }
}
